var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('amplify-connect',{attrs:{"query":_vm.getNewsArticleQuery},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loading = ref.loading;
var data = ref.data;
var errors = ref.errors;
return [(loading)?_c('fin-logo-full',{attrs:{"dark":"","loading":""}}):(errors.length > 0)?_c('div',[_vm._v("TODO error: "+_vm._s(errors))]):(data)?_c('div',[_c('fin-news-details',{attrs:{"value":data.getNewsArticle},on:{"close":function (){ return _vm.goBack({name: 'news'}); }}})],1):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }